(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["browiso-offer-b-reviews"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',(event)=>{if(event.target.closest('[data-source-review-close]'))event.target.closest('dialog').close();});
window.addEventListener('message',(event)=>{
  const frame=[...document.querySelectorAll('iframe[data-source-reviews]')].find((item)=>item.contentWindow===event.source);
  if(!frame||event.data?.type!=='browfi-reviews')return;
  if(Number.isFinite(event.data.height)&&event.data.height>0&&event.data.height<100000)frame.style.height=`${event.data.height}px`;
  if(event.data.write)document.querySelector('[data-source-review-form]')?.showModal();
  if(event.data.review){
    const review=event.data.review;
    const modal=document.querySelector('[data-source-review-dialog]');
    modal.querySelector('[data-source-review-name]').textContent=review.name;
    const rating=modal.querySelector('[data-source-review-rating]');
    rating.replaceChildren();
    const stars=Math.min(5,Math.max(0,Number(review.rating)||0));
    rating.setAttribute('aria-label',`${stars} out of 5 stars`);
    for(let i=0;i<stars;i++){
      const svg=document.createElementNS('http://www.w3.org/2000/svg','svg');
      svg.setAttribute('viewBox','0 0 24 24');svg.setAttribute('aria-hidden','true');
      const path=document.createElementNS('http://www.w3.org/2000/svg','path');
      path.setAttribute('fill','currentColor');
      path.setAttribute('d','m12 1 3.4 6.9 7.6 1.1-5.5 5.4 1.3 7.6L12 18.4 5.2 22l1.3-7.6L1 9l7.6-1.1Z');
      svg.append(path);rating.append(svg);
    }
    const date=modal.querySelector('[data-source-review-date]');
    date.textContent=review.date?new Date(review.date).toLocaleDateString():'';
    if(review.date)date.dateTime=new Date(review.date).toISOString();else date.removeAttribute('datetime');
    modal.querySelector('[data-source-review-text]').textContent=review.text;
    const image=modal.querySelector('[data-source-review-image]');
    const media=modal.querySelector('[data-source-review-media]');
    media.hidden=!review.image;
    image.dataset.portrait=String(Number(review.ratio)>1);
    const background=String(review.color||'').match(/rgb\([\d\s,]+\)/)?.[0]||'#eee';
    media.style.setProperty('--review-image-background',background);
    if(review.image){image.src=review.image;image.alt=review.imageAlt||'Customer review photo';}
    modal.showModal();modal.scrollTop=0;
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["marketkiss-product-return"] && !Shopify.designMode) return;
  try {
    (() => {
  const key = 'marketkiss.return-product.v1';
  const context = document.querySelector('[data-mk-product-context]');
  const bar = document.querySelector('[data-mk-return]');
  const remember = () => {
    if (!context) return;
    try {
      const item = JSON.parse(context.textContent);
      const url = new URL(item.url, location.origin);
      if (url.origin !== location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) return;
      const current = new URL(location.href);
      if (current.pathname === url.pathname) {
        url.search = current.search;
        url.hash = current.hash;
      }
      const offers = document.querySelector('[data-offer-test]');
      const configNode = document.querySelector('[data-offer-test-config]');
      if (offers && configNode) {
        const selected = offers.querySelector('[data-source-offer].is-selected');
        const count = Number(selected?.dataset.kitCount);
        const shades = [...(selected?.querySelectorAll('[data-offer-shade]') || [])].map(input => input.value);
        const config = JSON.parse(configNode.textContent);
        const variant = config.variantMap[shades.join('|')];
        if ([1, 2, 3].includes(count) && variant) {
          url.searchParams.set('kit', count);
          url.searchParams.delete(count === 1 ? 'bundle_variant' : 'variant');
          url.searchParams.set(count === 1 ? 'variant' : 'bundle_variant', variant);
        }
      }
      sessionStorage.setItem(key, JSON.stringify({ ...item, url: url.pathname + url.search + url.hash, time: Date.now() }));
    } catch {}
  };
  const hide = () => {
    if (bar) bar.hidden = true;
    document.body.classList.remove('mk-has-return');
  };
  const show = () => {
    if (!bar) return;
    hide();
    try {
      const item = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (!item?.title || !Number.isFinite(item.time) || Date.now() - item.time > 7200000) return;
      const url = new URL(item.url, location.origin);
      if (url.origin !== location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname) || url.pathname.endsWith('/full-cover-shipping-protection')) return;
      bar.querySelectorAll('[data-mk-return-link]').forEach(link => { link.href = url.href; });
      const title = bar.querySelector('[data-mk-return-title]');
      title.textContent = item.title;
      title.title = item.title;
      const image = bar.querySelector('[data-mk-return-image]');
      image.hidden = true;
      if (item.image) {
        const imageUrl = new URL(item.image, location.origin);
        const shopOrigin = new URL(bar.dataset.shopUrl, location.origin).origin;
        if (imageUrl.protocol === 'https:' && (imageUrl.origin === location.origin || imageUrl.origin === shopOrigin || imageUrl.hostname === 'cdn.shopify.com')) {
          image.src = imageUrl.href;
          image.hidden = false;
        }
      }
      bar.hidden = false;
      document.body.classList.add('mk-has-return');
    } catch {}
  };
  remember();
  show();
  document.addEventListener('click', event => {
    if (event.target.closest('a[href]')) remember();
  }, true);
  window.addEventListener('pagehide', remember);
  window.addEventListener('pageshow', () => { remember(); show(); });
  bar?.querySelector('[data-mk-return-close]').addEventListener('click', () => {
    hide();
    try { sessionStorage.removeItem(key); } catch {}
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["source-header"] && !Shopify.designMode) return;
  try {
    (() => {
  const cartLink=document.querySelector('[data-mk-cart-url]');
  if(cartLink){
    let pending=false;
    const syncCart=async()=>{
      if(pending)return;
      pending=true;
      try{
        const response=await fetch(cartLink.dataset.mkCartUrl+'.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
        if(!response.ok)return;
        const cart=await response.json();
        if(!Number.isInteger(cart.item_count)||cart.item_count<0)return;
        document.querySelectorAll('.mk-cart').forEach(link=>{
          const badge=link.querySelector('.cart-count-bubble');
          if(badge){badge.textContent=String(cart.item_count);badge.hidden=cart.item_count===0;badge.style.display=cart.item_count?'':'none';}
          link.setAttribute('aria-label',cartLink.dataset.mkCartLabel+' ('+cart.item_count+')');
        });
      }catch{}finally{pending=false;}
    };
    window.addEventListener('pageshow',syncCart);
    window.addEventListener('focus',syncCart);
    document.addEventListener('browfi:cart-added',syncCart);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["travel-sleep-header"] && !Shopify.designMode) return;
  try {
    (() => {
})();
  } catch(e) { console.error(e); }
})();

})();
